import type React from "react";
import { Box, Avatar, TextField, IconButton } from "@mui/material";
import PersonIcon from "@mui/icons-material/Person";
import SendIcon from "@mui/icons-material/Send";

interface AddCommentInputProps {
  value: string;
  onChange: (value: string) => void;
  onSubmit: () => void;
}

const AddCommentInput: React.FC<AddCommentInputProps> = ({
  value,
  onChange,
  onSubmit,
}) => {
  return (
    <Box
      sx={{
        display: "flex",
        gap: 1.5,
        mt: 2,
        alignItems: "center",
        p: 1.5,
        backgroundColor: "#fafafa",
        borderRadius: "8px",
      }}
    >
      <Avatar sx={{ backgroundColor: "#ff9800", width: 32, height: 32 }}>
        <PersonIcon sx={{ fontSize: 18 }} />
      </Avatar>
      <TextField
        fullWidth
        placeholder="Write a message here..."
        value={value}
        onChange={(e) => onChange(e.target.value)}
        variant="outlined"
        size="small"
        sx={{
          "& .MuiOutlinedInput-root": {
            backgroundColor: "#fff",
            borderRadius: "8px",
            fontSize: "13px",
          },
        }}
      />
      <IconButton
        onClick={onSubmit}
        disabled={!value.trim()}
        size="small"
        sx={{
          backgroundColor: "#1976d2",
          color: "#fff",
          width: 32,
          height: 32,
          "&:hover": {
            backgroundColor: "#1565c0",
          },
          "&:disabled": {
            backgroundColor: "#e0e0e0",
            color: "#9e9e9e",
          },
        }}
      >
        <SendIcon sx={{ fontSize: 18 }} />
      </IconButton>
    </Box>
  );
};

export default AddCommentInput;
